import { useEffect, useMemo, useState } from 'react'
import { Stack, Typography } from '@mui/material';
import { ExtraSmallButton } from '../custom';
import { EqualityOperator, EqualityOperatortoJson, getExpiryTypeLabel, strategyCriteriaList } from './StrategyTemplate.types';
import { OptionType, SecurityCategory_CategoryCode } from '../../proto/generated/security';
import { StrategyTemplateLegProto, StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType, StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType } from '../../proto/generated/strategy';
import { TransactionType } from '../../proto/generated/order';

type Props = {
    strategyLegs: StrategyTemplateLegProto[] | undefined
}

const StrategyLegsViewer = ({
    strategyLegs
}: Props) => {
    const [strategyCriteria, setStrategyCriteria] = useState(strategyCriteriaList()[0].key)

    useEffect(() => {
        if (!strategyLegs?.length && strategyCriteria === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.SAME_AS_PREVIOUS_LEG) {
            setStrategyCriteria(strategyCriteriaList()[0].key)
        }
    }, [strategyLegs?.length])

    const ifAnyWeeklyLeg = useMemo(() => {
        return strategyLegs.some((leg) => leg.expirySelection?.expirySelectionType ? [StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.WEEKLY, StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_WEEKLY].includes(leg.expirySelection.expirySelectionType) : false)
    }, [strategyLegs])

    const isCPSPCD = useMemo(() => {
        return [StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA, StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_PREMIUM, StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CP_ON_STRADDLE_PREMIUM].includes(strategyCriteria)
    }, [strategyCriteria])

    const showRolloverExpiry = useMemo(() => strategyLegs.some(
        (strategyLeg) =>
            strategyLeg.categoryCode === SecurityCategory_CategoryCode.OPTIONS &&
            ifAnyWeeklyLeg &&
            strategyLeg.expirySelection?.expirySelectionType &&
            [
                StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MONTHLY,
                StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_MONTHLY
            ].includes(strategyLeg.expirySelection.expirySelectionType)
    ), [ifAnyWeeklyLeg, strategyLegs])

    const showMinDays = useMemo(() => strategyLegs.some(
        (strategyLeg) =>
            strategyLeg.expirySelection?.expirySelectionType ===
            StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MINIMUM_DAYS_TO_MONTHLY_EXPIRY
    ), [strategyLegs])

    // const RenderAtmSelectionDropDown = useCallback((i = 0) => {
    //     const strategyCriteriaRender = strategyLegs[i].strikeCriteria?.strikeType
    //     const optionType = strategyLegs[i].optionType
    //     const CPCDtext = strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA ? 'CD' : 'CP'
    //     return (
    //         <FormControl sx={{ m: 0 }} variant="standard">
    //             {
    //                 (strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_PREMIUM || strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CP_ON_STRADDLE_PREMIUM || strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA) ?
    //                     <Box display="flex" alignItems="center" borderRadius={1} p={0}>
    //                         <FormControl variant="outlined">
    //                             <StyledSelect
    //                                 value={(strategyLegs[i].strikeCriteria?.parametersMap?.operator ?? EqualityOperator['~'])}
    //                                 sx={{ width: showRolloverExpiry && showMinDays ? '60px' : '100px', height: "24px", mr: showRolloverExpiry && showMinDays ? '10px' : "20px" }}
    //                             >
    //                                 <StyledMenuItem value={EqualityOperator['~']}>{`${CPCDtext}~`}</StyledMenuItem>
    //                                 <StyledMenuItem value={EqualityOperator['>=']}>{`${CPCDtext}>=`}</StyledMenuItem>
    //                                 <StyledMenuItem value={EqualityOperator['<=']}>{`${CPCDtext}<=`}</StyledMenuItem>
    //                             </StyledSelect>
    //                         </FormControl>

    //                         {
    //                             (
    //                                 strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_PREMIUM ||
    //                                 strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA
    //                             ) ?
    //                                 <>
    //                                     <TextField
    //                                         value={strategyLegs[i].strikeCriteria?.value}
    //                                         variant="outlined"
    //                                         placeholder="Type here"
    //                                         type='number'
    //                                         inputProps={(strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA ? {
    //                                             min: 0.01,
    //                                             max: 0.99,
    //                                             step: 0.01,
    //                                             sx: {
    //                                                 fontSize: '12px',
    //                                                 height: '24px',
    //                                                 padding: '5px 10px'
    //                                             }
    //                                         } : {
    //                                             sx: {
    //                                                 fontSize: '12px',
    //                                                 height: '24px',
    //                                                 padding: '5px 10px'
    //                                             }
    //                                         })
    //                                         }
    //                                         sx={{
    //                                             width: showRolloverExpiry && showMinDays ? '50px' : '60px',
    //                                             '& .MuiInputBase-root': {
    //                                                 fontSize: '12px',
    //                                                 height: '24px'
    //                                             },
    //                                             '& .Mui-disabled': {
    //                                                 color: theme => `${theme.palette.text.primary} !important`,
    //                                                 '-webkit-text-fill-color': theme => `${theme.palette.text.primary} !important`,
    //                                             }
    //                                         }}
    //                                     />
    //                                 </> :
    //                                 <>
    //                                     <FormControl>
    //                                         <StyledSelect
    //                                             MenuProps={{ sx: { zIndex: 13000 } }}
    //                                             sx={{ width: showRolloverExpiry && showMinDays ? '50px' : '60px', height: "24px" }}
    //                                             variant='outlined'
    //                                             id="strike-price-label"
    //                                             value={strategyLegs[i].strikeCriteria?.value}
    //                                         >

    //                                             {
    //                                                 Array.from({ length: 12 }, (_, i) => i + 1).map(i => {
    //                                                     return <StyledMenuItem value={i * 5} key={i}>{Math.abs(i * 5)}% SP</StyledMenuItem>
    //                                                 })
    //                                             }
    //                                         </StyledSelect>
    //                                     </FormControl>
    //                                 </>
    //                         }
    //                     </Box> :
    //                     <FormControl>
    //                         <StyledSelect
    //                             sx={{ height: "24px", textAlign: "center" }}
    //                             id="strike-price-label"
    //                             variant='outlined'
    //                             value={strategyLegs[i].strikeCriteria?.value}
    //                         >
    //                             {
    //                                 strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_POINT ?
    //                                     [
    //                                         ...Array.from({ length: 20 }, (_, i) => i - 20).map(i => (
    //                                             <StyledMenuItem value={i} key={`neg-${i}`}>
    //                                                 {optionType === OptionType.PE ? 'OTM' : 'ITM'} {Math.abs(i)}
    //                                             </StyledMenuItem>
    //                                         )),
    //                                         <StyledMenuItem value={0} key="atm">ATM</StyledMenuItem>,
    //                                         ...Array.from({ length: 20 }, (_, i) => i + 1).map(i => (
    //                                             <StyledMenuItem value={i} key={`pos-${i}`}>
    //                                                 {optionType === OptionType.CE ? 'OTM' : 'ITM'} {Math.abs(i)}
    //                                             </StyledMenuItem>
    //                                         ))
    //                                     ] :
    //                                     strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_PERCENTAGE ?
    //                                         [
    //                                             Array.from({ length: 40 }, (_, i) => i - 40).map(i => {
    //                                                 return <StyledMenuItem value={i * 0.25} key={i}>ATM-{Math.abs(i * 0.25)}%</StyledMenuItem>
    //                                             }),
    //                                             <StyledMenuItem value={0} key={i}>ATM</StyledMenuItem>,
    //                                             Array.from({ length: 40 }, (_, i) => i + 1).map(i => {
    //                                                 return <StyledMenuItem value={i * 0.25} key={i}>ATM+{Math.abs(i * 0.25)}%</StyledMenuItem>
    //                                             })
    //                                         ] :
    //                                         strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STRADDLE_WIDTH ?
    //                                             [
    //                                                 Array.from({ length: 40 }, (_, i) => i - 40).map(i => {
    //                                                     return <StyledMenuItem value={i * 0.25} key={i}>ATM-{Math.abs(i * 0.25)}*SP</StyledMenuItem>
    //                                                 }),
    //                                                 <StyledMenuItem value={0} key={i}>ATM</StyledMenuItem>,
    //                                                 Array.from({ length: 40 }, (_, i) => i + 1).map(i => {
    //                                                     return <StyledMenuItem value={i * 0.25} key={i}>ATM+{Math.abs(i * 0.25)}*SP</StyledMenuItem>
    //                                                 })
    //                                             ] :
    //                                             strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STANDARD_DEVIATION ?
    //                                                 [
    //                                                     Array.from({ length: 40 }, (_, i) => i - 40).map(i => {
    //                                                         return <StyledMenuItem value={i * 0.25} key={i}>ATM-{Math.abs(i * 0.25)}*SD</StyledMenuItem>
    //                                                     }),
    //                                                     <StyledMenuItem value={0} key={i}>ATM</StyledMenuItem>,
    //                                                     Array.from({ length: 40 }, (_, i) => i + 1).map(i => {
    //                                                         return <StyledMenuItem value={i * 0.25} key={i}>ATM+{Math.abs(i * 0.25)}*SD</StyledMenuItem>
    //                                                     })
    //                                                 ] : null
    //                             }
    //                         </StyledSelect>
    //                     </FormControl>
    //             }
    //         </FormControl>
    //     )
    // }, [strategyLegs, showRolloverExpiry, showMinDays])

    const getAtmSelectionText = (i = 0) => {
        const strikeCriteria = strategyLegs[i].strikeCriteria;
        const strategyCriteriaRender = strikeCriteria?.strikeType;
        if(strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.SAME_AS_PREVIOUS_LEG) {
            return i===0 ? '' : getAtmSelectionText(i-1)
        }
        const optionType = strategyLegs[i].optionType;
        const value = strikeCriteria?.value;
        const CPCDtext =
            strategyCriteriaRender ===
                StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA
                ? "CD"
                : "CP";

        // Closest Premium / CP Straddle / Closest Delta
        if (
            strategyCriteriaRender ===
            StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_PREMIUM ||
            strategyCriteriaRender ===
            StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CP_ON_STRADDLE_PREMIUM ||
            strategyCriteriaRender ===
            StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CLOSEST_DELTA
        ) {
            const unit = strategyCriteriaRender === StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.CP_ON_STRADDLE_PREMIUM ? '% SP' : ''
            const operator = strikeCriteria?.parametersMap?.operator ?? EqualityOperator["~"];
            return `${CPCDtext} ${EqualityOperatortoJson(operator)} ${value}${unit}`;
        }

        // ATM POINT
        if (
            strategyCriteriaRender ===
            StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_POINT
        ) {
            if (value === 0) return "ATM";
            if (value < 0)
                return `${optionType === OptionType.PE ? "OTM" : "ITM"} ${Math.abs(
                    value
                )}`;
            return `${optionType === OptionType.CE ? "OTM" : "ITM"} ${value}`;
        }

        // ATM PERCENTAGE
        if (
            strategyCriteriaRender ===
            StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.ATM_PERCENTAGE
        ) {
            if (value === 0) return "ATM";
            if (value < 0) return `ATM-${Math.abs(value)}%`;
            return `ATM+${value}%`;
        }

        // STRADDLE WIDTH
        if (
            strategyCriteriaRender ===
            StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STRADDLE_WIDTH
        ) {
            if (value === 0) return "ATM";
            if (value < 0) return `ATM-${Math.abs(value)}SP`;
            return `ATM+${value}SP`;
        }

        // STANDARD DEVIATION
        if (
            strategyCriteriaRender ===
            StrategyTemplateLegProto_StrikeCriteriaProto_StrikeType.STANDARD_DEVIATION
        ) {
            if (value === 0) return "ATM";
            if (value < 0) return `ATM-${Math.abs(value)}SD`;
            return `ATM+${value}SD`;
        }

        return String(value ?? "");
    };


    return (
        <>
            <Stack direction={'column'} spacing={1} alignItems={'flex-start'}>
                {
                    strategyLegs.length === 0 ? null :
                        strategyLegs.map((strategyLeg, i) => (
                            <Stack direction={'row'} key={i} sx={{ color: theme => theme.palette.text.primary, fontSize: '12px', fontWeight: 400 }} spacing={1} alignItems={'center'}>
                                {i + 1}.&nbsp;
                                <ExtraSmallButton
                                    className={`
                                                ${strategyLeg.transactionType === TransactionType.BUY ? 'buy-button' : 'sell-button'}
                                            `}
                                >
                                    {strategyLeg.transactionType === TransactionType.BUY ? 'B' : 'S'}
                                </ExtraSmallButton>&nbsp;

                                {getAtmSelectionText(i)} &nbsp;

                                {getExpiryTypeLabel(strategyLeg.expirySelection?.expirySelectionType)}
                                {
                                    (strategyLeg.expirySelection?.expirySelectionType === StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MINIMUM_DAYS_TO_MONTHLY_EXPIRY) ?
                                    `:${(strategyLeg.expirySelection?.minimumDaysToExpiry ?? 0)} ` : null
                                } &nbsp;

                                {strategyLeg.categoryCode === SecurityCategory_CategoryCode.OPTIONS ? (
                                    strategyLeg.optionType === OptionType.CE ? 'CE' : 'PE'
                                ) : (
                                    <Typography sx={{ textAlign: 'center', width: '32px', fontSize: "12px" }}>
                                        FUT
                                    </Typography>
                                )} &nbsp;

                                {`× ${strategyLeg.lots} Lot${strategyLeg.lots > 1 ? 's' : ''}`} &nbsp;

                                {/* {showRolloverExpiry && (
                                    <TableCell sx={{ padding: 0, borderBottom: "none" }}>
                                        {strategyLeg.categoryCode === SecurityCategory_CategoryCode.OPTIONS &&
                                            ifAnyWeeklyLeg &&
                                            strategyLeg.expirySelection?.expirySelectionType &&
                                            [StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MONTHLY,
                                            StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.NEXT_MONTHLY].includes(strategyLeg.expirySelection.expirySelectionType) ? (
                                            <FormControl>
                                                <Checkbox
                                                    checked={strategyLeg.expirySelection?.rolloverFlag ?? true}
                                                    sx={{
                                                        padding: 0,
                                                        width: '24px',
                                                        '&.Mui-disabled': {
                                                            color: theme => `${theme.palette.text.primary} !important`,
                                                            '-webkit-text-fill-color': theme => `${theme.palette.text.primary} !important`,
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        ) : null}
                                    </TableCell>
                                )}

                                {showMinDays && (
                                    <TableCell sx={{ padding: 0, borderBottom: "none" }}>
                                        {(strategyLeg.expirySelection?.expirySelectionType === StrategyTemplateLegProto_ExpirySelectionProto_ExpirySelectionType.MINIMUM_DAYS_TO_MONTHLY_EXPIRY) ? (

                                            <ExtraSmallTextField
                                                textFieldProps={{
                                                    value: strategyLeg.expirySelection?.minimumDaysToExpiry ?? 0,
                                                    type: 'number',
                                                    inputProps: {
                                                        sx: {
                                                            min: 1, max: 45,
                                                            maxWidth: 40
                                                        }
                                                    },
                                                    sx: {
                                                        '& .Mui-disabled': {
                                                            color: theme => `${theme.palette.text.primary} !important`,
                                                            '-webkit-text-fill-color': theme => `${theme.palette.text.primary} !important`,
                                                        }
                                                    }
                                                }}
                                            />
                                        ) : null}
                                    </TableCell>
                                )} */}
                            </Stack>
                        ))
                }
            </Stack>
        </>
    )
}

export default StrategyLegsViewer